/*eslint-disable*/
import api from '../'

class MessageApi {

    // POST: message
    static create(message) {
        return api.axios.post('/message', message)
            .then(response => response.data.message);
    }

    // GET: conversation
    static list(params, cancelToken = null) {
        return api.axios.get('/message', {params, cancelToken})
            .then(response => response.data)
    }

    static update(id, params) {
        return api.axios.put('/message/' + id, params)
            .then(response => response.data.message)
    }

    static updateSome(params) {
        return api.axios.put('/message', params)
            .then(response => response.data)
    }

    static delete(id) {
        return api.axios.delete('/message/' + id)
            .then(response => response.data)
    }
}

export default MessageApi;
